// extracted by mini-css-extract-plugin
export default {"link":"SearchPage_link__9NGiS","data":"SearchPage_data__MVjgv","details":"SearchPage_details__iBLXc"};